import { useSelector } from "react-redux";
import ChatState from "../../../../components/chat/chatState/ChatState";
import DisplayContainer from "../../../../components/displayContainer/DisplayContainer";
import CustomerSupportSidebarIcon from "../../../../components/icons/CustomerSupportSidebarIcon";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import ChatList from "./chatList/ChatList";
import ChatWindow from "./chatWindow/ChatWindow";
import styles from "./usersChat.module.css";

// plan "prime": the شات البرايم tab — the same page, Prime players' chats only.
const UsersChat = ({ plan = "all" }) => {
  const hasOpenChat = useSelector((state) =>
    Boolean(state.supportChat.activeChatId),
  );

  return (
    <div className={styles.container}>
      <TextWrapper textStyle="textTitle">
        {plan === "prime" ? "شات البرايم" : "شات المستخدمين"}
      </TextWrapper>
      <div className={styles.displayContainerWrapper}>
        <DisplayContainer className={styles.panel}>
          <div className={styles.shell}>
            <aside className={styles.listPane} dir="rtl">
              <ChatList plan={plan} />
            </aside>
            <section className={styles.windowPane} dir="rtl">
              {hasOpenChat ? (
                <ChatWindow />
              ) : (
                <ChatState
                  icon={<CustomerSupportSidebarIcon />}
                  title="اختر محادثة"
                  text="اختر محادثة من القائمة لقراءة رسائل اللاعب والرد عليه."
                />
              )}
            </section>
          </div>
        </DisplayContainer>
      </div>
    </div>
  );
};

export default UsersChat;
